import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { UserApiService } from 'src/app/services/api/user.api.service';

@Injectable()
export class RoleGuardService implements CanActivate {
  constructor(
    public authService: AuthService,
    public userApiService: UserApiService,
    public router: Router,
  ) {}

  async canActivate(): Promise<boolean> {
    const role = await this.userApiService.getAdminRole();
    if (role !== 'mowa_admin') {
      this.router.navigateByUrl('/');
      return false;
    }

    return true;
  }
}
